// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__pMAUQ","error":"Textarea_error__hj09t","readonly":"Textarea_readonly__2KZuU","disabled":"Textarea_disabled__ec9CZ"};